import React from "react"
import { Link } from "resha"
import babyYoda1x from "../Assets/baby_yoda@1x.png"
import babyYoda2x from "../Assets/baby_yoda@2x.png"

interface NothingMatchedProps {
    messageVariant: "maybe-try" | "try"
    noFilterLink?: string
    anchor?: string
}

export function NothingMatched({
    messageVariant,
    noFilterLink,
    anchor = "nothing-matched"
}: NothingMatchedProps) {
    const link =
        noFilterLink === undefined ? undefined : (
            <Link to={noFilterLink} testId="clear-filter-link">
                clearing your filters
            </Link>
        )

    return (
        <div
            id={anchor}
            className="p-32 flex flex-col items-center justify-center flex-grow text-rhino-800"
        >
            <img
                srcSet={`${babyYoda1x} 1x, ${babyYoda2x} 2x`}
                alt="Super cute baby yoda"
            />
            <p className="text-xl text-center mt-6 mb-2 font-semibold">
                There's nothing here
            </p>
            {link === undefined ? null : messageVariant === "try" ? (
                <span>Try {link}</span>
            ) : (
                <span>Maybe try {link}?</span>
            )}
        </div>
    )
}
